export default __webpack_public_path__ + "static/media/our-team-member-08.0d001388.jpg";